<!-- <p-dialog
  header="Edit Request"
  [modal]="true"
  [visible]="showDialog()"
  [style]="{ width: '42rem' }"
  [breakpoints]="{ '800px': '75vw', '575px': '90vw' }"
> -->
<p-fluid>
  <form [formGroup]="requestForm" class="flex flex-col gap-4 mt-2 mb-4">
    <p-floatlabel variant="on">
      <input
        pInputText
        formControlName="name"
        [invalid]="requestForm.controls.name.invalid && requestForm.controls.name.touched"
        autocomplete="off"
      />
      <label>{{ 'internal.requests.name' | translate }}</label>
    </p-floatlabel>

    <div class="flex flex-row gap-4 justify-between flex-desktop">
      <div>
        <label>{{ 'internal.requests.startDate' | translate }}</label>
        <p-datepicker
          formControlName="startdate"
          [invalid]="
            requestForm.controls.startdate.invalid && requestForm.controls.startdate.touched
          "
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [inline]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>

      <div>
        <label>{{ 'internal.requests.endDate' | translate }}</label>
        <p-datepicker
          formControlName="enddate"
          [invalid]="requestForm.controls.enddate.invalid && requestForm.controls.enddate.touched"
          showIcon
          iconDisplay="input"
          [minDate]="requestForm.value.startdate"
          [showTime]="true"
          [inline]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>
    </div>

    <div class="flex flex-col gap-4 flex-mobile">
      <p-floatlabel variant="on">
        <p-datepicker
          formControlName="startdate"
          [invalid]="
            requestForm.controls.startdate.invalid && requestForm.controls.startdate.touched
          "
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.requests.startDate' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <p-datepicker
          formControlName="enddate"
          [invalid]="requestForm.controls.enddate.invalid && requestForm.controls.enddate.touched"
          showIcon
          iconDisplay="input"
          [minDate]="requestForm.value.startdate"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.requests.endDate' | translate }}</label>
      </p-floatlabel>
    </div>

    <p-floatlabel variant="on">
      <input
        pInputText
        formControlName="location"
        [invalid]="requestForm.controls.location.invalid && requestForm.controls.location.touched"
        autocomplete="off"
      />
      <label>{{ 'internal.requests.location' | translate }}</label>
    </p-floatlabel>

    <div class="flex flex-row gap-4 flex-mobile-col">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          formControlName="contact"
          [invalid]="requestForm.controls.contact.invalid && requestForm.controls.contact.touched"
          autocomplete="off"
        />
        <label>{{ 'internal.requests.contact' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          formControlName="contactMail"
          [invalid]="
            requestForm.controls.contactMail.invalid && requestForm.controls.contactMail.touched
          "
          autocomplete="off"
        />
        <label>{{ 'internal.requests.contactMail' | translate }}</label>
      </p-floatlabel>
    </div>

    <p-floatlabel variant="on">
      <textarea
        pTextarea
        formControlName="equipment"
        [invalid]="requestForm.controls.equipment.invalid && requestForm.controls.equipment.touched"
        rows="10"
        cols="30"
        style="resize: none"
        class="h-full"
      ></textarea>
      <label>{{ 'internal.requests.equipment' | translate }}</label>
    </p-floatlabel>
  </form>
</p-fluid>

<div class="flex justify-end gap-2">
  @if ((request?._id ?? undefined) != undefined && hasPerm('promote_to_event')) {
    <p-button
      [label]="'internal.requests.convertToEvent' | translate"
      severity="secondary"
      (onClick)="convertToEvent()"
    />
  }
  @if (request._id != undefined && hasPerm('delete_requests')) {
    <p-button
      [label]="'general.delete' | translate"
      severity="danger"
      (onClick)="deleteRequest()"
    />
  }
  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="closeDialog()" />
  <p-button
    [label]="'general.save' | translate"
    [disabled]="!requestForm.valid"
    (onClick)="closeDialog(true)"
  />
</div>
<!-- </p-dialog> -->
